// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"195":"login1","398":"login4","577":"login3","768":"login2","791":"login5"}[chunkId] + "." + {"195":"e4720e2a","398":"f5ea8ae9","577":"1fe8b642","768":"f5ea8ae9","791":"7a8b0b4e"}[chunkId] + ".css";
};